import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/svgs/login-logo.svg';
const _hoisted_1 = {
  class: "login-page"
};
const _hoisted_2 = {
  class: "main-content"
};
const _hoisted_3 = {
  key: 0,
  class: "dot-error-msg"
};
const _hoisted_4 = {
  key: 1,
  class: "dot-error-msg"
};
import { reactive, ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { validateDot } from "@/api/discount-membership";
import { useProductStore } from "@/store/product";
import { ACCOUNT_TYPE } from "@/const";
import { storage } from "@/utils/storage";
export default /*@__PURE__*/Object.assign({
  name: "LoginPage"
}, {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const productStore = useProductStore();
    const form = reactive({
      dot: ""
    });
    const isFocused = ref(false);
    const loginFormRef = ref(null);
    const dotError = ref(false);
    const btnLoading = ref(false);
    const formatError = ref(false);
    onMounted(async () => {
      storage.removeItem("dot");
      productStore.$reset();
    });

    // Listen to dot input and automatically clear error prompts when the content changes
    watch(() => form.dot, val => {
      if (val) {
        dotError.value = false;
        formatError.value = false;
      }
    });
    const handleBlur = () => {
      isFocused.value = false;
      if (form.dot && !/^\d+$/.test(form.dot)) {
        formatError.value = true;
      }
    };
    const handleNext = async () => {
      btnLoading.value = true;

      // Check format first
      if (form.dot && !/^\d+$/.test(form.dot)) {
        formatError.value = true;
        btnLoading.value = false;
        return;
      }
      loginFormRef.value.validate(async valid => {
        if (valid && form.dot) {
          try {
            const res = await validateDot({
              dot: form.dot.toString()
            });
            if (res.code === 200 && res.message === "success") {
              await Promise.all([productStore.fetchProductInfo(ACCOUNT_TYPE.DIAMOND_ANNUAL), productStore.fetchProductInfo(ACCOUNT_TYPE.FLEET_MONTH)]);
              productStore.dot = form.dot.toString();
              // set 24 hours expiration
              storage.setItem("dot", form.dot.toString(), 24);
              dotError.value = false;
              btnLoading.value = false;
              router.push({
                path: "/discount-membership"
              });
            } else {
              dotError.value = true;
              btnLoading.value = false;
            }
          } catch (e) {
            dotError.value = true;
            btnLoading.value = false;
          }
        } else {
          dotError.value = true;
          btnLoading.value = false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [_createVNode(_component_el_card, {
        class: "login-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "login-logo-wrap"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: "Northland Insurance Logo",
          class: "login-logo"
        })], -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "login-title"
        }, [_createElementVNode("span", {
          class: "highlight"
        }, "Get 50% OFF "), _createElementVNode("span", null, "Your Annual Trucker Path Subscription")], -1)), _createVNode(_component_el_form, {
          model: form,
          ref_key: "loginFormRef",
          ref: loginFormRef,
          class: "login-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "dot",
            class: _normalizeClass(["float-label-input", {
              'is-focused': isFocused.value || form.dot,
              'is-error': dotError.value || formatError.value
            }])
          }, {
            default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("label", {
              class: "float-label"
            }, "Your DOT", -1)), _createVNode(_component_el_input, {
              modelValue: form.dot,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.dot = $event),
              onFocus: _cache[1] || (_cache[1] = $event => isFocused.value = true),
              onBlur: handleBlur,
              class: "float-el-input",
              placeholder: ""
            }, null, 8, ["modelValue"]), formatError.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Invalid Format ")) : dotError.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Sorry, only Northland insureds are eligible for the discount ")) : _createCommentVNode("", true)]),
            _: 1,
            __: [2]
          }, 8, ["class"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "login-btn",
              loading: btnLoading.value,
              disabled: !form.dot || formatError.value,
              color: !form.dot || formatError.value ? '#CBCFD9' : '#4066D4',
              onClick: handleNext
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("NEXT")])),
              _: 1,
              __: [3]
            }, 8, ["loading", "disabled", "color"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1,
        __: [4, 5]
      })])]);
    };
  }
});